import React, { useEffect, useRef } from 'react'
import {
  Tooltip,
  ToastContainer,
  Loading,
  Button,
  SpacingVertical
} from 'mailup-web-components'
import Header from './Header'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  modalWarningAliasState,
  pageDataState,
  pageState,
  progressBarState
} from './recoil/states/state'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'
import ModalConfirmLeave from 'Components/ModalConfirmLeave'
import { Costs } from './components/costs/Costs'
import ModalWarningAlias from './components/ModalWarningAlias'
import { Credits } from './components/credits/Credits'
import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import BoxProgress from './components/BoxProgress'
import { useIntl } from 'react-intl'
import {
  getQueueProgressCallback,
  initCallback,
  resetCallback,
  startCallback
} from './recoil/callbacks/callbacks'
import { useParams } from 'react-router-dom'
import { evalCondition } from 'mailup-react-helpers'
import { BEQUEUE_CONFIG_STATE_COMPLETED } from 'Api/beQueueApi'

const SmsQueue = () => {
  const { loaded, loading, error, severity, exitPage } = useRecoilValue(
    pageState
  )

  const { idSms, idInvio, idConfiguration } = useParams()

  const resetPageState = useRecoilCallback(resetCallback, [])
  const init = useRecoilCallback(initCallback, [])
  const intl = useIntl()
  const {
    queueStatus,
    variant,
    queuedPercentage,
    toBeQueued,
    processGlobalStatus
  } = useRecoilValue(progressBarState)
  const { RecipientsReachedWithoutAlias } = useRecoilValue(pageDataState)
  useBeforeUnload(exitPage)

  const setModalWarningAliasState = useSetRecoilState(modalWarningAliasState)
  const start = useRecoilCallback(startCallback, [])
  const getQueueProgress = useRecoilCallback(getQueueProgressCallback, [])

  useEffect(() => {
    !loaded &&
      init(
        +idInvio,
        +idSms,
        idConfiguration !== undefined ? +idConfiguration : -1
      )
    return () => {
      resetPageState()
    }
  }, [])

  const timerGlobalStatus = useRef(true)

  useEffect(() => {
    getQueueProgress(idConfiguration, +idInvio)
  }, [])

  useEffect(() => {
    if (processGlobalStatus) {
      timerGlobalStatus.current = setInterval(() => {
        getQueueProgress(idConfiguration, +idInvio)
      }, 1000)
    }
    return () => clearInterval(timerGlobalStatus.current)

    // if (processGlobalStatus === false) {
    //   checkScheduleAbTestById()
    // }
  }, [processGlobalStatus])

  const onClickStart = () => {
    if (RecipientsReachedWithoutAlias > 0) {
      setModalWarningAliasState(prev => ({
        ...prev,
        show: true,
        sendingType: 'Immediate'
      }))
    } else {
      start(idInvio, idSms, 'Immediate')
    }
  }

  const onClickSchedule = () => {
    if (RecipientsReachedWithoutAlias > 0) {
      setModalWarningAliasState(prev => ({
        ...prev,
        show: true,
        sendingType: 'Scheduled'
      }))
    } else {
      start(idInvio, idSms, 'Scheduled')
    }
  }

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />
      <Loading open={loading} />
      <ModalConfirmLeave />
      <ModalWarningAlias />
      <PageContainer className='c-sms-queue'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() =>
            init(
              +idInvio,
              +idSms,
              idConfiguration !== undefined ? +idConfiguration : -1
            )
          }
        />
        {!error && loaded && (
          <>
            <BoxProgress
              queueStatus={queueStatus}
              variant={variant}
              queuedPercentage={queuedPercentage}
              toBeQueued={toBeQueued}
            />
            <Credits />
            <Costs />

            <div>
              {!evalCondition('uo:NOENQUEUE') &&
                !evalCondition('co:NOIMMEDIATESEND') &&
                evalCondition('uo:SEND') && (
                  <Button
                    kind='primary'
                    onClick={() => onClickStart()}
                    data-mu-test='sms-queue-start'
                    disabled={queueStatus !== BEQUEUE_CONFIG_STATE_COMPLETED}
                  >
                    {intl.formatMessage({ id: 'Load.QueueSms.btStart' })}
                  </Button>
                )}
              {!evalCondition('uo:NOENQUEUE') &&
                !evalCondition('uo:NOSCHED') &&
                !evalCondition('uo:NOSENDSMS') &&
                evalCondition('uo:SEND') && (
                  <Button
                    kind='secondary'
                    onClick={() => onClickSchedule()}
                    data-mu-test='sms-queue-ScheduleCampaign'
                    disabled={queueStatus !== BEQUEUE_CONFIG_STATE_COMPLETED}
                  >
                    {intl.formatMessage({ id: 'Load.Common.ScheduleCampaign' })}
                  </Button>
                )}
            </div>
            <SpacingVertical />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default SmsQueue
